import type { InjectionKey } from 'vue';
import { inject, provide } from 'vue';

type ContextProvider<TContext> = {
  readonly key: InjectionKey<TContext>;
  readonly provideContext: (ctx: TContext) => void;
  readonly useContext: () => TContext;
};

export const createContextProvider = <TContext>(name: string): ContextProvider<TContext> => {
  const key: InjectionKey<TContext> = Symbol(`${name}:context`);
  const provideContext = (ctx: TContext): void => {
    provide(key, ctx);
  };
  const useContext = (): TContext => {
    const ctx = inject(key);
    if (!ctx) {
      throw new Error(`use${name}Context must be called inside ${name} provider subtree`);
    }
    return ctx;
  };
  return { key, provideContext, useContext };
};
